var map = {
	"./aa.png": "cc40",
	"./banner.jpg": "d801",
	"./banner_code.png": "573a",
	"./cate1.jpg": "b231",
	"./cate2.jpg": "47ca",
	"./cate3.jpg": "b18b",
	"./close.png": "3644",
	"./hotel1.png": "20ca",
	"./hotel1_1.png": "f3d2",
	"./hotel1_2.png": "36a5",
	"./hotel1_3.png": "8bef",
	"./hotel1_4.png": "243f",
	"./hotel1_min.png": "cd92",
	"./hotel2.png": "dde0",
	"./hotel2_1.png": "7ecd",
	"./hotel2_2.png": "4293",
	"./hotel2_3.png": "2e7a",
	"./hotel2_4.png": "9ee8",
	"./hotel2_min.png": "7138",
	"./hotel3_1.png": "ae9d",
	"./hotel3_2.png": "0e01",
	"./hotel3_3.png": "a3b4",
	"./hotel3_4.png": "c301",
	"./hotel3_min.png": "7cd9",
	"./hotel_1.png": "41eb",
	"./hotel_2.png": "da04",
	"./hotel_3.png": "82ed",
	"./icon_1.png": "3b10",
	"./icon_2.png": "b8fd",
	"./icon_3.png": "a35c",
	"./map2.png": "d269",
	"./play.png": "1958",
	"./poster_1.jpg": "a4b1",
	"./poster_2.jpg": "f6c4",
	"./poster_3.jpg": "ea0d",
	"./slide11.png": "23dd",
	"./slide12.png": "c1b2",
	"./slide13.png": "26a0",
	"./slide14.png": "2db6",
	"./slide15.png": "b945",
	"./slide21.png": "fea6",
	"./slide22.png": "246e",
	"./slide23.png": "3f1f",
	"./slide24.png": "002c",
	"./slide25.png": "bc6c",
	"./video1.mp4": "1197",
	"./video2.mp4": "3a70",
	"./video3.mp4": "bb45"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c350";